// extracted by mini-css-extract-plugin
export default {"subscriptionContainer":"subscription_subscriptionContainer__BnbHI","cardWrapper":"subscription_cardWrapper__p1nyw"};